import Tooltip from "../Tooltip";

export default function SegmentedPicker<
    Options extends readonly { label: string; key: string; tooltip?: string }[],
>({
    options,
    selectedOption,
    onOptionChange,
    dataTestId,
}: {
    options: Options;
    selectedOption: Options[number];
    onOptionChange: (option: Options[number]) => void;
    dataTestId?: string;
}) {
    const selectedOptionIndex = options.findIndex(
        (option) => option.key === selectedOption.key,
    );

    return (
        <div
            data-testid={dataTestId}
            className="relative flex gap-2 bg-brand-lightGray rounded-lg p-1.5 text-xs"
        >
            {options.map((option) => (
                <Tooltip
                    key={option.key}
                    title={option.tooltip}
                    disabled={!option.tooltip}
                    wrapperContainerClassName="flex items-center justify-center flex-1 z-1"
                >
                    <button
                        key={option.key}
                        data-testid={
                            dataTestId && `${dataTestId}-option-${option.key}`
                        }
                        onClick={() => onOptionChange(option)}
                        className="grow p-1.5 -m-1.5"
                    >
                        {option.label}
                    </button>
                </Tooltip>
            ))}
            <div
                className="absolute top-0 left-0 w-[calc(33.33%-6px)] h-[calc(100%-6px)] bg-brand-white rounded-lg m-[3px] transition-transform duration-150"
                style={{
                    transform: `translateX(calc(${selectedOptionIndex * 100}% + ${selectedOptionIndex * 6}px))`,
                }}
            />
        </div>
    );
}
